import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {
  // 获取联系人
  [TYPES.CONTACT_LIST.REQUEST](state: IState) {
    state.contactList.loading = true;
  },
  [TYPES.CONTACT_LIST.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.contactList.loading = false;
    state.contactList.infos = data;
  },
  [TYPES.CONTACT_LIST.FAILED](state: IState) {
    state.contactList.infos = [];
    state.contactList.loading = false;
  },

  // 更新联系人
  [TYPES.CONTACT_UPDATE.REQUEST](state: IState) {
    state.contactUpdate.loading = true;
  },
  [TYPES.CONTACT_UPDATE.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.contactUpdate.result = data;
    state.contactUpdate.loading = false;
  },
  [TYPES.CONTACT_UPDATE.FAILED](state: IState) {
    state.contactUpdate.result = {};
    state.contactUpdate.loading = false;
  }
};
